import { makeVar } from "@apollo/client"

interface UserData {
  username: string
  profilePic: string
  userId: string
  email?: string
  phone_number?: string
  country_code?: string
}
export const isAuthenticatedVar = makeVar<boolean>(false)

export const userData = makeVar<UserData>({
  username: "",
  profilePic: "",
  userId: "",
  email: "",
  phone_number: "",
  country_code : ""
})
